import script from "./ToggleButtonGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleButtonGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ToggleButtonGroup.vue?vue&type=style&index=0&id=2eb19606&lang=scss"

const __exports__ = script;

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
